import React, { useRef, useState } from 'react';

export default function StorePlantItemsEditor({ element, section, initialNames, aspectChanges = [], canDeclareAspect, disabled, onClose, onApply }) {
  const nextKey = useRef(0);
  const [error, setError] = useState('');
  const [rows, setRows] = useState(() => initialNames.map(name => {
    const declarations = (element.itemDeclarations || []).filter(d => d.name === name);
    const declaration = declarations.length === 1 ? declarations[0] : null;
    const aspect = aspectChanges.find(d => d.name === name)?.aspect || declaration?.aspect || '';
    return { key: `row-${++nextKey.current}`, originalName: name, name, aspect, changed: false };
  }));
  function update(key, patch) {
    setRows(previous => previous.map(row => row.key === key ? { ...row, ...patch } : row));
  }
  function apply(event) {
    event.preventDefault();
    const names = rows.map(row => row.name.trim());
    if (names.some(name => !name || name.length > 500 || /[\p{Cc}\p{Cf}]/u.test(name))) return setError('Preencha um nome válido em cada item.');
    if (new Set(names.map(name => name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase())).size !== names.length) return setError('Cada mercadoria deve aparecer uma única vez neste ponto.');
    if (canDeclareAspect && rows.some(row => !['REGULAR', 'IRREGULAR'].includes(row.aspect))) return setError('Declare Regular ou Irregular para cada item.');
    onApply(names, canDeclareAspect ? rows.filter(row => row.changed || aspectChanges.some(d => d.name === row.name.trim()))
      .map(row => ({ elementId: element.id, name: row.name.trim(), aspect: row.aspect })) : []);
  }
  return <section className="plant-context-editor" aria-label="Editar mercadorias do elemento">
    <header><h3>Editar elemento</h3><button type="button" aria-label="Fechar editor de mercadorias" onClick={onClose}>×</button></header>
    <form onSubmit={apply}>
      <label className="plant-context-label">Seção<input value={section || 'Elemento sem seção'} readOnly /></label>
      <span className="plant-context-label">Itens</span>
      <div className="plant-item-rows">{rows.map((row, index) => <div className="plant-item-row" key={row.key}>
        <input aria-label={`Mercadoria ${index + 1}`} value={row.name} disabled={disabled} maxLength={500}
          onChange={event => update(row.key, { name: event.target.value, aspect: '', changed: true })} />
        <select aria-label={`Regularidade de ${row.name || `item ${index + 1}`}`} value={row.aspect}
          disabled={disabled || !canDeclareAspect} onChange={event => update(row.key, { aspect: event.target.value, changed: true })}>
          <option value="" disabled>Declarar…</option><option value="REGULAR">Regular</option><option value="IRREGULAR">Irregular</option>
        </select>
        <button type="button" aria-label={`Remover item ${index + 1}`} disabled={disabled}
          onClick={() => setRows(previous => previous.filter(item => item.key !== row.key))}>×</button>
      </div>)}</div>
      <button className="plant-item-add" type="button" disabled={disabled} onClick={() => setRows(previous => [...previous,
        { key: `row-${++nextKey.current}`, originalName: null, name: '', aspect: '', changed: true }])}>Adicionar item +</button>
      <p className="plant-context-note">{canDeclareAspect ? 'A regularidade é declarada por você, item a item. Sortimento habitual não confirma estoque atual.' : 'Regularidade tipada disponível somente no piloto autorizado.'}</p>
      {error && <p role="alert">{error}</p>}
      <footer><button type="button" onClick={onClose}>Cancelar</button><button className="plant-context-primary" type="submit" disabled={disabled}>Aplicar à planta</button></footer>
      <p className="plant-context-note">As alterações serão gravadas ao salvar a planta.</p>
    </form>
  </section>;
}
